<template>
  <div
    v-loading="loading"
    class="l-page l-page--detail"
  >
    <!-- 页面头部 Start -->
    <div class="l-page__header c-page__header">
      <!-- 页面标题 -->
      <h2 class="c-page__header-title">
        用户基本信息修改
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div class="c-page__header-btns">
        <el-button
          type="primary"
          icon="kestrel-icon ki-save"
          @click="handleSave()"
        >
          保存
        </el-button>
        <el-button
          icon="kestrel-icon ki-close"
          @click="closeNavTabAndTo()"
        >
          关闭
        </el-button>
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 页面主内容：详情 Start -->
    <div class="l-page__body l-page--detail__body">
      <hm-page-card class="c-card--detail">
        <el-form
          ref="fd"
          class="c-form"
          :model="fd"
          :rules="fdRules"
          :inline="true"
          :validate-on-rule-change="false"
          label-position="right"
          label-width="118px"
          label-suffix="："
        >
          <el-row class="c-form__row">
            <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              用户基本信息
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="用户编码"
                prop="userVO.userCode"
              >
                <span class="c-form__read">
                  {{ fd.userVO.userCode }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="用户名称"
                prop="userVO.userName"
              >
                <el-input
                  v-model.trim="fd.userVO.userName"
                  class="c-form__input"
                  placeholder=""
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="联系电话"
                prop="userVO.tel"
              >
                <el-input
                  v-model.trim="fd.userVO.tel"
                  class="c-form__input"
                  placeholder=""
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="有效标志"
                prop="userVO.valid"
              >
                <el-radio-group
                  v-model="fd.userVO.valid"
                  class="c-form__radio-group"
                >
                  <el-radio label="Y">
                    有效
                  </el-radio>
                  <el-radio label="N">
                    无效
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="邮箱"
                prop="userVO.email"
              >
                <el-input
                  v-model.trim="fd.userVO.email"
                  class="c-form__input"
                  placeholder=""
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="数据来源"
                prop="userVO.sourceType"
              >
                {{ fd.userVO.sourceTypeName }}
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="是否主账号"
                prop="SFZZH"
              >
                <el-radio-group
                  v-model="SFZZH"
                  class="c-form__radio-group"
                >
                  <el-radio label="Y">
                    是
                  </el-radio>
                  <el-radio label="N">
                    否
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col
              v-for="(attrUserItem, index) in attrUserList"
              :key="'attrUser'+ index"
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                :label="attrUserItem.attrName"
                :prop="'userVO.attrs.' + attrUserItem.attrKey"
              >
                <template v-if="attrUserItem.enums">
                  <template v-if="enums[attrUserItem.enums] && Object.keys(enums[attrUserItem.enums]).length <= 2">
                    <el-radio-group
                      v-model="fd.userVO.attrs[attrUserItem.attrKey]"
                      class="c-form__radio-group"
                    >
                      <el-radio
                        v-for="value in enums[attrUserItem.enums]"
                        :key="value.id"
                        :label="value.id"
                      >
                        {{ value.text }}
                      </el-radio>
                    </el-radio-group>
                  </template>
                  <template v-else>
                    <el-select
                      v-model="fd.userVO.attrs[attrUserItem.attrKey]"
                      class="c-form__select"
                      style="width: 100%;"
                      placeholder=""
                      clearable
                    >
                      <el-option
                        v-for="(value) in enums[attrUserItem.enums]"
                        :key="value.id"
                        :label="value.text"
                        :value="value.id"
                      />
                    </el-select>
                  </template>
                </template>
                <template v-else-if="attrUserItem.attrType === 'String' || attrUserItem.attrType === 'Double'">
                  <el-input
                    v-model.trim="fd.userVO.attrs[attrUserItem.attrKey]"
                    class="c-form__input"
                    placeholder=""
                  />
                </template>
                <template v-else-if="attrUserItem.attrType === 'Date'">
                  <el-date-picker
                    v-model.trim="fd.userVO.attrs[attrUserItem.attrKey]"
                    class="c-form__date"
                    type="date"
                    placeholder="选择日期"
                    value-format="timestamp"
                  />
                </template>
                <template v-else-if="attrUserItem.attrType === 'Image'">
                  <image-upload
                    ref="files"
                    v-model.trim="fd.userVO.attrs[attrUserItem.attrKey]"
                    :file-api="$config.ctx.hmfileApi"
                    show-file-list
                    accept="image/*"
                    :data="uploadFd"
                    list-type="picture-card"
                  >
                    <i
                      slot="default"
                      class="el-icon-plus"
                    />
                  </image-upload>
                </template>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="所属组织"
                prop="capacityVO.deptCode"
              >
                <span class="c-form__read">
                  {{ fd.capacityVO.deptName }}
                </span>
              </el-form-item>
            </el-col>

            <el-col
              v-for="(attrCapacityItem, index) in attrCapacityList"
              :key="'attrCapacity'+ index"
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                :label="attrCapacityItem.attrName"
                :prop="'capacityVO.attrs.' + attrCapacityItem.attrKey"
              >
                <template v-if="attrCapacityItem.enums">
                  <span class="c-form__read">
                    <!-- {{ fd.capacityVO.attrs[attrCapacityItem.attrKey] | enums(attrCapacityItem.enums) }} -->
                    {{ fd.capacityVO.attrs[attrCapacityItem.attrKey+'_name'] }}
                  </span>
                </template>
                <template v-else-if="attrCapacityItem.attrType === 'String'">
                  <span class="c-form__read">
                    {{ fd.capacityVO.attrs[attrCapacityItem.attrKey] }}
                  </span>
                </template>
                <template v-else-if="attrCapacityItem.attrType === 'Date'">
                  <span class="c-form__read">
                    {{ fd.capacityVO.attrs[attrCapacityItem.attrKey] | date('yyyy-MM-dd') }}
                  </span>
                </template>
              </el-form-item>
            </el-col>
            <!-- col空白占位填充 -->
            <el-col
              v-if="attrCapacityList.length%2 > 0 || attrUserList.length%2 > 0"
              class="c-form__col c-form__placeholder"
              :span="12"
            />
            <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              用户登录账号信息
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="登录账号"
                prop="userAuthVO.account"
              >
                <span class="c-form__read">
                  {{ fd.userAuthVO.account }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="身份有效期起"
                prop="userAuthVO.effectStartDate"
              >
                <el-date-picker
                  v-model="fd.userAuthVO.effectStartDate"
                  class="c-form__date"
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="身份有效期止"
                prop="userAuthVO.effectEndDate"
              >
                <el-date-picker
                  v-model="fd.userAuthVO.effectEndDate"
                  class="c-form__date"
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
  </div>
</template>

<script>
import { userService } from './user.service';

import EditUser from '@/features/system/attr/user/editUser.vue';
export default {
  // 基于扩展字段的单身份用户修改
  name: 'SingleEditUser',
  extends: EditUser,
  data () {
    return {
      uploadFd: { // 上传服务入参
        meta: [
          {
            key: 'zjz',
            value: null
          }
        ]
      },
      SFZZH: 'N',
      SFTSSPT: 'N'
    };
  },
  methods: {
    /**
     * @description: 保存
     * @param {*}
     * @return {*}
     */
    handleSave () {
      this.$refs.fd.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.fd.userVO.attrs.SFZZH = this.SFZZH;
          this.fd.capacityVO.capacityName = this.fd.userVO.userName;
          this.fd.capacityVO.effectStartDate = this.fd.userAuthVO.effectStartDate;
          this.fd.capacityVO.effectEndDate = this.fd.userAuthVO.effectEndDate;
          this.fd.userVO.attrs.ZGZSZP = this.fd.userVO.attrs.ZGZSZP instanceof Array ? '' : this.fd.userVO.attrs.ZGZSZP;
          this.fd.userVO.attrs.ZJZP = this.fd.userVO.attrs.ZJZP instanceof Array ? '' : this.fd.userVO.attrs.ZJZP;
          userService.update(this.fd)
            .then(rsp => {
              this.$alert('修改成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              // 跳转到扩展字段单身份用户列表页面
              this.closeNavTabAndTo({ name: 'singleUserManage', params: { isRefresh: true } }, true);
            })
            .catch(err => {
              console.error('修改保存出错', err);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.SFZZH = this.fd.userVO.SFZZH;
      this.SFTSSPT = this.fd.userVO.SFTSSPT;
    });
  }
};
</script>
